var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M12.4711 4.47108C12.7314 4.21073 12.7314 3.78862 12.4711 3.52827C12.2107 3.26792 11.7886 3.26792 11.5283 3.52827L7.99967 7.05687L4.47108 3.52827C4.21073 3.26792 3.78862 3.26792 3.52827 3.52827C3.26792 3.78862 3.26792 4.21073 3.52827 4.47108L7.05687 7.99967L3.52827 11.5283C3.26792 11.7886 3.26792 12.2107 3.52827 12.4711C3.78862 12.7314 4.21073 12.7314 4.47108 12.4711L7.99967 8.94248L11.5283 12.4711C11.7886 12.7314 12.2107 12.7314 12.4711 12.4711C12.7314 12.2107 12.7314 11.7886 12.4711 11.5283L8.94248 7.99967L12.4711 4.47108Z",
    fill: "#014935"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.ffa65faca2099053879b5e2723d059de.svg";
export { ForwardRef as ReactComponent };